import { render, staticRenderFns } from "./QuestionHeader.vue?vue&type=template&id=60ec2266&scoped=true"
import script from "./QuestionHeader.ts?vue&type=script&lang=ts&external"
export * from "./QuestionHeader.ts?vue&type=script&lang=ts&external"
import style0 from "./QuestionHeader.vue?vue&type=style&index=0&id=60ec2266&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec2266",
  null
  
)

export default component.exports